/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentFolderTemplate } from './DocumentFolderTemplate';
import {
    DocumentFolderTemplateFromJSON,
    DocumentFolderTemplateFromJSONTyped,
    DocumentFolderTemplateToJSON,
    DocumentFolderTemplateToJSONTyped,
} from './DocumentFolderTemplate';

/**
 * List of document folder templates for a company.
 * @export
 * @interface ListDocumentFolderTemplatesResponse
 */
export interface ListDocumentFolderTemplatesResponse {
    /**
     * 
     * @type {Array<DocumentFolderTemplate>}
     * @memberof ListDocumentFolderTemplatesResponse
     */
    items: Array<DocumentFolderTemplate>;
}

/**
 * Check if a given object implements the ListDocumentFolderTemplatesResponse interface.
 */
export function instanceOfListDocumentFolderTemplatesResponse(value: object): value is ListDocumentFolderTemplatesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ListDocumentFolderTemplatesResponseFromJSON(json: any): ListDocumentFolderTemplatesResponse {
    return ListDocumentFolderTemplatesResponseFromJSONTyped(json, false);
}

export function ListDocumentFolderTemplatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocumentFolderTemplatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DocumentFolderTemplateFromJSON)),
    };
}

export function ListDocumentFolderTemplatesResponseToJSON(json: any): ListDocumentFolderTemplatesResponse {
    return ListDocumentFolderTemplatesResponseToJSONTyped(json, false);
}

export function ListDocumentFolderTemplatesResponseToJSONTyped(value?: ListDocumentFolderTemplatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DocumentFolderTemplateToJSON)),
    };
}

